// extracted by mini-css-extract-plugin
export default {"loader":"PrivateImage_loader__irlBy"};